import {styled} from '@mui/material';

export const Container = styled('div')`
	opacity: 0;
	position: fixed;
	top: 0;
	left: 0;
	z-index: -1;
`;
